/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_CommandInputs */

const en_directory_agents_command = /** @type {(inputs: Directory_Agents_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read https://seekai.dev/skill.md and follow the instructions to submit your product to Seek AI`)
};

const zh_directory_agents_command = /** @type {(inputs: Directory_Agents_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取 https://seekai.dev/skill.md 并按照说明把你的产品提交到 Seek AI`)
};

/**
* | output |
* | --- |
* | "Read https://seekai.dev/skill.md and follow the instructions to submit your product to Seek AI" |
*
* @param {Directory_Agents_CommandInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_command = /** @type {((inputs?: Directory_Agents_CommandInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_CommandInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_command(inputs)
	return zh_directory_agents_command(inputs)
});
export { directory_agents_command as "directory.agents.command" }